import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { IconContext } from "@phosphor-icons/react";
import { App } from "./App";
import { initTheme } from "./useTheme";
import "./i18n/index";
import "../../design-tokens/brand.css";
import "./index.css";
import "./styles/workstation.css";
import "./styles/print.css";

initTheme();

// H4 — Sentry + Web Vitals are lazy-loaded only when configured / in
// production. Keeps the dev / preview bundles untouched.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  void import("./sentry").then(({ initSentry }) =>
    initSentry({
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      tracesSampleRate: Number(
        import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1,
      ),
    }),
  );
}

if (import.meta.env.PROD) {
  void import("./web-vitals");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Вес по канону 13-design-tokens раздел 8 — Light для UI (решение Димы
        2026-08-12, ТД-143 развилка A; снимает расхождение C8-комментария
        с канон-файлом). fill — активное/выбранное, bold — акцент/hero
        (задаются per-icon пропом weight). Размер — контекстный per-icon,
        поэтому в дефолт не зашит. Оба приложения держат один дефолт —
        admin/src/main.tsx зеркалит эту строку. */}
    <IconContext.Provider value={{ weight: "light" }}>
      <App />
    </IconContext.Provider>
  </StrictMode>
);
